import Edit from '@/views/settings/settings'

export default {
  path: '/settings',
  redirect: '/settings/edit',
  name: 'settings',
  meta: {
    auth: {
      redirect: {
        name: 'settings.index'
      },
      forbiddenRedirect: '/dashboard'
    },
    label: 'Distribuidores'
  },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [{
    path: '',
    name: 'settings.index',
    component: Edit,
    meta: {
      auth: true,
      roles: ['SUPER'],
      forbiddenRedirect: '/dashboard',
      label: 'Index'
    }
  },
  {
    path: 'edit',
    name: 'settings.edit',
    component: Edit,
    meta: {
      auth: true,
      roles: ['SUPER'],
      forbiddenRedirect: '/dashboard',
      label: 'Editar'
    }
}]
}
